export default {
  api: {
    // url: 'http://localhost/canto/api/',
    url: 'https://canto.org/api/',
    key: '9bU7aLpQFkhxYnrZz3pN'
  },

  title: {
    pre: 'Canto Caribbean'
  },

  google: {
    api: 'AIzaSyByicflh_u69XeDmmW8Q0ugl2N_Bj8pnCs',
    style: [],

    login: {
      clientId: '742439354351-b2pomofm7ekhsv1flsidpa5g8u0og45q.apps.googleusercontent.com',
      clientSecret: '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'
    }
  }, 
}